import i18next from "i18next";
import axiosInstance from "./axiosInstance";

export const getDataCommon = async (url) => {
  const lang = i18next?.language ?? "th";

  let urlLang = url;

  if (lang === "en") {
    urlLang = `en/${url}`;
  }

  try {
    const response = await axiosInstance.get(urlLang);

    return response.data;
  } catch (error) {
    throw error;
  }
};
